/*
 * Sprint V30 (Fr 27.02.2026) — Retention Upgrade Banner (Cockpit).
 * Andreas-Direktive: DEZENT + POSITIV formuliert. Kein Sekunden-Countdown,
 * Tage-Anzeige, letzter Tag Stunden-Anzeige. Kurz+knapp, keine Salesy-Copy.
 * Details liegen auf der Pricing-Seite (Verlinkung).
 */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function UpgradeOfferBanner({ user }) {
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const tier = String(user?.license_tier || "").toLowerCase();
    if (tier !== "pro_solo_monthly") return;
    let alive = true;
    api.get("/upgrade-offer/status")
      .then(({ data }) => { if (alive) setStatus(data); })
      .catch(() => { /* silent */ });
    return () => { alive = false; };
  }, [user?.license_tier]);

  if (!status?.eligible) return null;

  const days = status.days_remaining ?? 0;
  const hours = status.hours_remaining ?? 0;
  const mode = status.display_mode || "days";

  const timerLabel =
    mode === "hours"
      ? `noch ${hours} ${hours === 1 ? "Stunde" : "Stunden"} gültig`
      : `noch ${days} ${days === 1 ? "Tag" : "Tage"} gültig`;

  const handleClick = () => {
    api.post("/upgrade-offer/clicked").catch(() => {});
    navigate("/pricing?ref=cockpit_upgrade_banner");
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="cockpit-upgrade-offer-banner"
      data-days-remaining={days}
      data-mode={mode}
      className="w-full flex items-center justify-between gap-3 rounded-xl border border-amber-200 dark:border-amber-800/50 bg-amber-50 dark:bg-amber-950/30 hover:bg-amber-100 dark:hover:bg-amber-950/50 px-4 py-3 transition-colors text-left"
    >
      <span className="flex items-center gap-3 min-w-0">
        <span className="flex-shrink-0 w-8 h-8 rounded-full bg-amber-500/15 dark:bg-amber-400/15 flex items-center justify-center">
          <Sparkles className="w-4 h-4 text-amber-700 dark:text-amber-300" strokeWidth={1.75} aria-hidden="true" />
        </span>
        <span className="min-w-0">
          <span className="block text-sm font-semibold text-slate-900 dark:text-white">
            Dein Jahres-Vorteil: <span className="text-amber-800 dark:text-amber-200">{timerLabel}</span>
          </span>
          <span className="block text-xs text-slate-600 dark:text-slate-400">
            Wechsel auf Jahresabo + Fokus-Typen-PowerPaket geschenkt · Details ansehen
          </span>
        </span>
      </span>
      <ArrowRight className="w-4 h-4 flex-shrink-0 text-slate-400" aria-hidden="true" />
    </button>
  );
}
